import {
  Breakpoint,
  ContactInfobox,
  ContactInfoboxVariant,
  Markdown,
  Typography,
  TypographyElement,
  TypographyVariant,
} from '@elearning-platform/ui';
import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { ContactData } from '../../interfaces';

import {
  ContactInfoboxWrapper,
  ContactsWrapper,
  ContentContainer,
  ContentWrapper,
  ImageContainer,
  RightTextContainer,
  StyledMarkdown,
  StyledTypography,
  Wrapper,
} from './contactSlide.styled';
import { ContactSlideProps } from './contactSlide.types';

export const ContactSlide: React.FC<ContactSlideProps> = (props: ContactSlideProps): JSX.Element => {
  const { baseUrl, data }: ContactSlideProps = props;
  const isSmallDesktop: boolean = useMediaQuery({
    query: Breakpoint.SmallDesktop,
  });

  return (
    <Wrapper>
      <ContentWrapper>
        <Typography variant={isSmallDesktop ? TypographyVariant.DisplayXL : TypographyVariant.DisplaySM}>
          {data.header}
        </Typography>
        <ContentContainer>
          <Typography tag={TypographyElement.div} variant={TypographyVariant.TextLG}>
            <Markdown text={data.text} />
          </Typography>
          {!!data.mainContact && (
            <ContactInfoboxWrapper>
              <ContactInfobox
                email={data.mainContact.email}
                name={data.mainContact.name}
                phone={data.mainContact.phone}
                variant={data.mainContact.withMarkdown ? ContactInfoboxVariant.WithMarkdown : ContactInfoboxVariant.Default}
              />
            </ContactInfoboxWrapper>
          )}
          <ContactsWrapper>
            {data.contactDetails.map((contact: ContactData): JSX.Element => (
              <ContactInfoboxWrapper key={`${contact.name}_${contact.phone}`}>
                <ContactInfobox
                  email={contact.email}
                  name={contact.name}
                  phone={contact.phone}
                  variant={contact.withMarkdown ? ContactInfoboxVariant.WithMarkdown : ContactInfoboxVariant.Default}
                />
              </ContactInfoboxWrapper>
            ))}
          </ContactsWrapper>
        </ContentContainer>
      </ContentWrapper>
      {!!isSmallDesktop && (
        <ImageContainer $image={baseUrl + data.image} $withImageText={!!data.imageText}>
          {!!data.imageText && (
            <RightTextContainer>
              <StyledTypography tag={TypographyElement.div} variant={TypographyVariant.TextSM}>
                <StyledMarkdown text={data.imageText} />
              </StyledTypography>
            </RightTextContainer>
          )}
        </ImageContainer>
      )}
      {(!isSmallDesktop && !!data.imageText) && (
        <RightTextContainer>
          <StyledTypography tag={TypographyElement.div} variant={TypographyVariant.TextSM}>
            <StyledMarkdown text={data.imageText} />
          </StyledTypography>
        </RightTextContainer>
      )}
    </Wrapper>
  );
};
